import { useState, useEffect } from 'react'
import { useUser } from 'context/user/User'
import { useContainerClick } from 'context/dash/ContainerClick'
import establishmentsApi from 'api/requests/establishments'
import Loader from 'components/_UI/Loader'
import { ProductCardsContainer } from './products.styled'
import { ContentProductCard } from './products.styled'
import ProductCard from './ProductCard'

export default function EstablishmentsProductsList ({
    onProductClick = () => {},
    onDropdownAction = () => {},
    refreshKey
}) {
    const { user } = useUser()
    const { containerClick } = useContainerClick()
    const [loading, setLoading] = useState(true)
    const [products, setProducts] = useState([])
    const [selected, setSelected] = useState(false)

    useEffect(() => {
        if (containerClick) {
            setSelected(false)
        }
    }, [containerClick])

    async function getProducts () {
        try {
            setLoading(true)

            const response= await establishmentsApi.getProducts(user?.establishments[0].slug)
                    
            setProducts(response?.data?.data)
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }

    function handleProductClick (product, index) {
        const editProductPayload = {
            ...product,
            action: 'edit',
            quantity: product?.batches[0]?.quantity_available,
        };

        onProductClick(editProductPayload);
        setSelected(index);
    }

    useEffect(() => {
        getProducts()
    }, [refreshKey])
    
    return (
        <>
            {
                loading ? 
                    <Loader></Loader> :
                    <ProductCardsContainer>
                        {
                            products && products.map((product, index)=> (
                                <ContentProductCard key={product.id}>
                                    <ProductCard
                                        data={product}
                                        onMoreClick={() => setSelected(index)}
                                        dropDownVisible={index === selected}
                                        visibleMoreAction
                                        onProductClick={() => handleProductClick(product, index)}
                                        onDropdownAction={e => { onDropdownAction({ action: e, ...product}) }}
                                    />
                                </ContentProductCard>
                            ))
                        }
                    </ProductCardsContainer>
            }
        </>
    )
}